var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movieList row"},_vm._l((_vm.movies),function(movie){return _c('MovieListItem',{key:movie.id,attrs:{"movie":movie}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }